import React from "react";
import { CreateConstructionObjectDto } from "../../../dtos/catalogs/ConstructionObject/CreateConstructionObjectDto";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { IAppEntity } from "../../entities";
import ConstructionObjectDetail from "../../../components/Pages/Catalogs/ConstructionObject/ConstructionObjectDetail";
import ConstructionObjectList from "../../../components/Pages/Catalogs/ConstructionObject/ConstructionObjectList";
import { ConstructionObjectService } from "../../../services/catalogs/ConstructionObjectService";
import { NFLookupConstructionObject } from "../../../components/Shared/NewForms/NFLookupConstructionObject";

export const ConstructionObject: IAppEntity = {
  entityType: "catalog",
  title: "Construction Object",
  pluralTitle: "ConstructionObjects",
  apiUrl: "ConstructionObjects", //needs to be checked the first letter
  apiEnum: ReferenceTypes.CatalogConstructionObject,
  getDetailViewComponent(
    model: any,
    modelUpdatedEvent: (model: any) => void
  ): any {
    return React.createElement(ConstructionObjectDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    });
  },
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(ConstructionObjectList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupConstructionObject, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService() {
    return new ConstructionObjectService(this.apiUrl);
  },
  getEmptyModel(): CreateConstructionObjectDto {
    return {
      name: "",
    };
  },
};
